// extracted by mini-css-extract-plugin
export var arrow = "arrow-module--arrow--d47cc";
export var blue = "arrow-module--blue--9a25f";
export var down = "arrow-module--down--ce980";
export var icon = "arrow-module--icon--d65bb";
export var left = "arrow-module--left--aa288";
export var up = "arrow-module--up--c7be7";
export var white = "arrow-module--white--ddcb6";